import Auth from 'label-insight-auth'
import createActions from './actions'
import createReducer from './reducer'

const env = process.env.NODE_ENV

export const _auth = new Auth({
  env: env === 'test' ? 'development' : env,

  // uncomment to manually test automatic logout
  // expires: 10,
})

export const actions = createActions(_auth)
export const reducer = createReducer(actions)

export default {
  actions,
  reducer,
  _auth,
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/lib/auth/index.js